import { render } from "./CardStackDisplay.vue?vue&type=template&id=38703b25&ts=true"
import script from "./CardStackDisplay.vue?vue&type=script&lang=ts"
export * from "./CardStackDisplay.vue?vue&type=script&lang=ts"

import "./CardStackDisplay.vue?vue&type=style&index=0&id=38703b25&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__